<template>
    <section class="delivery-summary-item">

        <div class="info-rows">
            <div class="text-row">
                <p class="text-row-label">Started By</p>
                <p class="text-row-value">{{ deliveryInfo.mailTransPicklist.userAccountName }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Started At</p>
                <p class="text-row-value">{{ deliveryInfo.mailTransPicklist.createdAt }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Total Items</p>
                <p class="text-row-value">{{ deliveryInfo.mailItemCount }}</p>
            </div>
            <div class="text-row">
                <p class="text-row-label">Items Remaining</p>
                <p class="text-row-value">{{ deliveriesRemaining }}</p>
            </div>
        </div>

        <!-- Show Detail Button -->
        <button
            role="button"
            type="button"
            class="button is-outlined button-with-icon element-bottom-margin"
            @click="toggleShowDetail()"
        >
            Details
            <MaterialDesignIcon
                class="icon-spacing"
                :class="{ 'rotate-icon': showDetail }"
                className="chevron-down"
                pxSize="24"
            />
        </button>

        <!-- Detailed Area -->
        <ListDeliveryDetail
            v-if="showDetail"
            :mailItemList="deliveryInfo.mailItems"
            class="element-bottom-margin"
        />

        <!-- Resume Button -->
        <button
            role="button"
            type="button"
            class="button is-link is-outlined button-with-icon"
            @click="resumeButtonHandler()"
        >
            Resume
            <MaterialDesignIcon
                class="icon-spacing"
                className="chevron-double-right"
                pxSize="24"
            />
        </button>
    </section>
</template>

<script>
// Components
import MaterialDesignIcon from '@/components/base/MaterialDesignIcon';
import ListDeliveryDetail from './deliverySummary/ListDeliveryDetail';

export default {
    name: 'DeliverySummary',
    components: {
        MaterialDesignIcon,
        ListDeliveryDetail,
    },
    props: {
        deliveryInfo: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showDetail: false,
        };
    },
    computed: {
        /** @returns { Number } */
        deliveriesRemaining() {
            return this.deliveryInfo.mailItems
                .filter( ( item ) => !item.dateDelivered )
                .length;
        },
    },
    methods: {
        toggleShowDetail() {
            this.showDetail = !this.showDetail;
        },
        async resumeButtonHandler() {
            await this.$store.dispatch( 'Mail/Delivery/Current/transformAndSetPicklistItems', { list: this.deliveryInfo.mailItems } );
            await this.$router.push( { path: '/mail/delivery/transit' } );
        },
    },
};
</script>

<style scoped lang="scss">

.rotate-icon {
    transform: rotate( 180deg );
}
.icon-spacing {
    margin-left: 0.5rem;
}
.button-with-icon {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    padding-top: 0;
}

.delivery-summary-item {
    display: flex;
    flex-flow: column nowrap;
    background-color: white;
    padding: 1rem;
    border-radius: 4px;
    box-shadow: $variables-material-shadow-1;
}

.info-rows {
    display: flex;
    flex-flow: column nowrap;
    >.text-row {
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid gainsboro;
    }
}
.text-row {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    >.text-row-label {
        margin-right: 1rem;
    }
}

.text-row-label {
    font-weight: 600;
    color: $colors-grey-darken-3;
}

.button-toggle-details {
    /*margin-bottom: 1rem;*/
}

.button-resume {
    /*margin-top: 1rem;*/
}
.element-bottom-margin {
    margin-bottom: 1rem;
}

@include mixins-above(tablet) {
    //
}
</style>
